export default __webpack_public_path__ + "static/media/funnel-chart.daba2855.svg";